<template lang="pug">
    div(class="overflow-hidden leading-5")
        p(v-for="file in files")
            //- TODO: Add logic to display the right thumb (pdf icon etc.. using typeId)
            template(v-if="file.key")
                img(
                    src="@/assets/common/file-img.svg"
                    alt="image"
                    width="16"
                    height="16"
                    class="float-left mr-3"
                    loading="lazy"
                )
                a(:href="$getImageUrl(file.key, file.filename)" target="_blank" v-html="file.title")
            template(v-else)
                img(
                    src="@/assets/common/file-pdf.svg"
                    alt="pdf"
                    width="16"
                    height="16"
                    class="float-left mr-3"
                    loading="lazy"
                )
                a(:href="getFileUrl(file.folder, file.filename)" target="_blank" v-html="file.title")
</template>

<script>
import { getFileUrl } from '../../_helpers/getFileUrl'

export default {
    props: {
        files: {
            type: Array,
            required: true,
        },
    },
    methods: {
        getFileUrl,
    },
}
</script>
